import { useEffect } from 'react'
import { authApi } from '../api/authApi'
import { authActions } from '../model/authSlice'
import { readAccessToken, readRefreshToken } from '../session/tokens'
import { SESSION_EXPIRED, SessionExpiredError } from '../session/sessionEvents'
import { useAppDispatch, useAppSelector } from '@/app/store/hooks'

let pending: ReturnType<typeof authApi.me> | null = null

export function AuthBootstrap() {
  const dispatch = useAppDispatch()
  const status = useAppSelector((state) => state.auth.status)

  useEffect(() => {
    const expire = () => dispatch(authActions.expired())
    window.addEventListener(SESSION_EXPIRED, expire)
    return () => window.removeEventListener(SESSION_EXPIRED, expire)
  }, [dispatch])

  useEffect(() => {
    if (status !== 'checking' || window.location.pathname === '/auth/callback') return
    if (!readAccessToken() && !readRefreshToken()) {
      dispatch(authActions.anonymous())
      return
    }
    let active = true
    pending ??= authApi.me().finally(() => { pending = null })
    void pending
      .then((user) => { if (active) dispatch(authActions.authenticated(user)) })
      .catch((error) => {
        if (active) dispatch(error instanceof SessionExpiredError ? authActions.expired() : authActions.failed())
      })
    return () => { active = false }
  }, [dispatch, status])
  return null
}
